module.exports = __webpack_public_path__ + "static/media/artwork-mobile.3fbc91a8.jpg";